import { Grid, Modal } from "antd-mobile";
import { useState } from "react";
import { useIntl } from "react-intl";
import EqiupItem from "../../../../components/ECards/EqiupItem";
export default function useEqiupsModal() {
  const intl = useIntl()
  const show = ({
    onConfrim = () => {},
    onCancel = () => {},
    equips = [],
    defaultId = "",
  }) => {
    let selectItem = {};
    return Modal.show({
      afterClose:onCancel,
      title: intl.formatMessage({id:'components.equips_modal.title',defaultMessage:"選擇裝備"}),
      bodyClassName: "runbit_modal runbit_modal_25",
      showCloseButton: true,
      actions: [
        {
          key: "1",
          className: "border_btn",
          text: intl.formatMessage({id:'components.equips_modal.cancel',defaultMessage:"返回上一頁"}),
        },
        {
          key: "2",
          className: "primary_btn",
          text: intl.formatMessage({id:'components.equips_modal.confrim',defaultMessage:"添加"}),
          primary: true,
        },
      ],
      onAction: (action, index) => {
        if (action.key === "1") {
          onCancel();
        }
        if (action.key === "2") {
          onConfrim(selectItem);
        }
      },
      closeOnAction: false,
      content: (
        <EquipsModal
          equips={equips}
          defaultId={defaultId}
          onSelect={(item) => {
            selectItem = item;
          }}
        />
      ),
    });
  };
  return {
    show,
  };
}

function EquipsModal({ equips, defaultId, onSelect = () => {} }) {
  const [sid,setSId] =useState(defaultId)
  return (
    <div className="text-center" style={{minHeight: '50vh'}}>
      <Grid columns={2} gap={8}>
        {equips.map((e) => (
          <Grid.Item key={e.id}>
            <EqiupItem
              checked={sid === e.id}
              eqiup={e}
              onClick={() => {
                console.log("item", e);
                setSId(e.id)
                onSelect(e);
              }}
            />
          </Grid.Item>
        ))}
      </Grid>
    </div>
  );
}
